var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.add_test_screen
        ? [
            _vm.hasResults
              ? _c(
                  "q-alert",
                  {
                    staticClass: "q-mb-sm",
                    attrs: {
                      color: "warning",
                      icon: "fas fa-exclamation-triangle"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t" +
                        _vm._s(_vm.$t("test_has_user_results")) +
                        "\n\t\t"
                    )
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "row gutter-sm" }, [
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-12" },
                [
                  _c("q-select", {
                    attrs: {
                      options: _vm.test_types.map(function(e) {
                        return { label: _vm.$t(e.slug), value: e.value }
                      }),
                      "float-label": _vm.$t("test_type"),
                      error: _vm.$v.live_class_test_type.$error,
                      disable: _vm.hasResults
                    },
                    on: { input: _vm.$v.live_class_test_type.$touch },
                    model: {
                      value: _vm.live_class_test_type,
                      callback: function($$v) {
                        _vm.live_class_test_type = $$v
                      },
                      expression: "live_class_test_type"
                    }
                  })
                ],
                1
              ),
              _vm.live_class_test_type
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c(
                        "q-alert",
                        {
                          attrs: {
                            color: "secondary",
                            icon: "fas fa-exclamation-triangle"
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t(_vm.getTestTypeDescription)) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-12" },
                [
                  _c(
                    "q-field",
                    { attrs: { count: 256 } },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("title"),
                          error: _vm.$v.title.$error
                        },
                        on: { input: _vm.$v.title.$touch },
                        model: {
                          value: _vm.title,
                          callback: function($$v) {
                            _vm.title = $$v
                          },
                          expression: "title"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.testProperties.use_max_attempts
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("maximum_attempts_quantity"),
                          error: _vm.$v.maximum_attempts.$error,
                          disable: _vm.hasResults
                        },
                        on: { input: _vm.$v.maximum_attempts.$touch },
                        model: {
                          value: _vm.maximum_attempts,
                          callback: function($$v) {
                            _vm.maximum_attempts = $$v
                          },
                          expression: "maximum_attempts"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.testProperties.use_time
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.live_class_test_type === 6 ||
                            _vm.live_class_test_type === 7,
                          expression:
                            "live_class_test_type === 6 || live_class_test_type === 7"
                        }
                      ],
                      staticClass: "col-xs-12 col-sm-12"
                    },
                    [
                      _c("q-datetime", {
                        attrs: {
                          type: "time",
                          "float-label": _vm.$t("time_to_answer"),
                          error: _vm.$v.time_to_answer.$error,
                          disable: _vm.hasResults,
                          format: "HH:mm:ss"
                        },
                        on: { input: _vm.$v.time_to_answer.$touch },
                        model: {
                          value: _vm.time_to_answer,
                          callback: function($$v) {
                            _vm.time_to_answer = $$v
                          },
                          expression: "time_to_answer"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-6" },
                [
                  _c("q-datetime", {
                    attrs: {
                      type: "date",
                      "float-label": _vm.$t("avaliable_in"),
                      format: "DD/MM/YYYY",
                      clearable: ""
                    },
                    model: {
                      value: _vm.available_in,
                      callback: function($$v) {
                        _vm.available_in = $$v
                      },
                      expression: "available_in"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-6" },
                [
                  _c(
                    "q-field",
                    {
                      attrs: {
                        helper: _vm.$t("leave_it_blank_to_use_training_score")
                      }
                    },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "number",
                          "float-label": _vm.$t("test_score"),
                          error: _vm.$v.test_score.$error
                        },
                        on: { input: _vm.$v.test_score.$touch },
                        model: {
                          value: _vm.test_score,
                          callback: function($$v) {
                            _vm.test_score = $$v
                          },
                          expression: "test_score"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-6" },
                [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("random_questions")))
                  ]),
                  _c("q-btn-toggle", {
                    attrs: {
                      "toggle-color": _vm.getColorRandomizeQuestions,
                      options: _vm.randomize_questions_options
                    },
                    model: {
                      value: _vm.randomize_questions,
                      callback: function($$v) {
                        _vm.randomize_questions = $$v
                      },
                      expression: "randomize_questions"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-6" },
                [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("random_answers")))
                  ]),
                  _c("q-btn-toggle", {
                    attrs: {
                      "toggle-color": _vm.getColorRandomizeAnswers,
                      options: _vm.randomize_answers_options
                    },
                    model: {
                      value: _vm.randomize_answers,
                      callback: function($$v) {
                        _vm.randomize_answers = $$v
                      },
                      expression: "randomize_answers"
                    }
                  })
                ],
                1
              )
            ]),
            _c("q-table", {
              staticClass: "q-mt-lg",
              attrs: {
                data: _vm.questions,
                columns: _vm.columns_questions,
                pagination: _vm.server_pagination,
                loading: _vm.loading,
                "row-key": "id",
                "no-data-label": _vm.$t("no_data_avaliable"),
                "no-results-label": _vm.$t("no_results_found"),
                "loading-label": _vm.$t("loading_data"),
                "rows-per-page-label": _vm.$t("items_per_page"),
                "rows-per-page-options": [0],
                "binary-state-sort": ""
              },
              on: {
                "update:pagination": function($event) {
                  _vm.server_pagination = $event
                },
                request: _vm.request_questions
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "top",
                    fn: function(props) {
                      return [
                        _c("div", { staticClass: "q-table-title" }, [
                          _vm._v(_vm._s(_vm.$t("questions")))
                        ]),
                        _c("div", { staticClass: "col" }),
                        _vm.questions.length > 0
                          ? _c("q-btn", {
                              staticClass: "q-mr-sm",
                              attrs: {
                                color: "secondary",
                                icon: "far fa-check-square",
                                label: _vm.$t("preview")
                              },
                              on: {
                                click: function($event) {
                                  _vm.show_test_preview = true
                                }
                              }
                            })
                          : _vm._e(),
                        _c("q-btn", {
                          staticClass: "q-mr-sm",
                          attrs: {
                            color: "secondary",
                            icon: "fas fa-file-upload",
                            label: _vm.$t("import_test")
                          },
                          on: {
                            click: function($event) {
                              return _vm.importTest(0)
                            }
                          }
                        }),
                        _c("q-btn", {
                          attrs: {
                            color: "secondary",
                            icon: "fas fa-plus",
                            label: _vm.$t("new"),
                            disable: _vm.hasResults
                          },
                          on: {
                            click: function($event) {
                              return _vm.showQuestion(0)
                            }
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "header",
                    fn: function(props) {
                      return _c(
                        "q-tr",
                        { attrs: { props: props } },
                        _vm._l(props.cols, function(col) {
                          return _c(
                            "q-th",
                            { key: col.name, attrs: { props: props } },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(_vm.$t(col.label)) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          )
                        }),
                        1
                      )
                    }
                  },
                  {
                    key: "body",
                    fn: function(props) {
                      return _c(
                        "q-tr",
                        { attrs: { props: props } },
                        [
                          _c(
                            "q-td",
                            {
                              key: "id",
                              attrs: { "auto-width": "", props: props }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(props.row.id) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            { key: "title", attrs: { props: props } },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(props.row.title.substring(0, 100)) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            {
                              key: "qty_answers",
                              attrs: { "auto-width": "", props: props }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(props.row.qty_answers) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            {
                              key: "is_mandatory",
                              attrs: { "auto-width": "", props: props }
                            },
                            [
                              _c("q-icon", {
                                attrs: {
                                  name: props.row.is_mandatory
                                    ? "fas fa-check"
                                    : "fas fa-ban",
                                  color: props.row.is_mandatory
                                    ? "positive"
                                    : "negative",
                                  size: "1.2rem"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "q-td",
                            {
                              key: "status",
                              attrs: { "auto-width": "", props: props }
                            },
                            [
                              _c(
                                "q-chip",
                                {
                                  staticClass: "full-width",
                                  attrs: {
                                    small: "",
                                    icon: _vm.getIconStatus(props.row.status),
                                    color: _vm.getColorStatus(props.row.status)
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t(_vm.getStatus(props.row.status))
                                      ) +
                                      "\n\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "q-td",
                            {
                              key: "actions",
                              attrs: { "auto-width": "", props: props }
                            },
                            [
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    round: "",
                                    color: "primary",
                                    icon: "fas fa-pencil-alt"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.showQuestion(props.row.actions)
                                    }
                                  }
                                },
                                [
                                  _c("q-tooltip", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t("view_or_edit_tooltip")) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    round: "",
                                    color: "negative",
                                    icon: "far fa-trash-alt",
                                    disable: _vm.hasResults
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.confirmRemove(
                                        props.row.actions
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("q-tooltip", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t("delete_tooltip")) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }
                  }
                ],
                null,
                false,
                1290222079
              )
            }),
            _c("div", { staticClass: "row gutter-sm q-mt-md" }, [
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-12" },
                [
                  _c("q-input", {
                    attrs: {
                      "float-label": _vm.$t(
                        "number_of_exam_questions_leave_blank_to_use_all"
                      ),
                      error: _vm.$v.qty_total_questions.$error,
                      disable: _vm.hasResults
                    },
                    on: { input: _vm.$v.qty_total_questions.$touch },
                    model: {
                      value: _vm.qty_total_questions,
                      callback: function($$v) {
                        _vm.qty_total_questions = $$v
                      },
                      expression: "qty_total_questions"
                    }
                  })
                ],
                1
              ),
              _vm.testProperties.use_minimum_score
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("minimum_score_approval"),
                          error: _vm.$v.minimum_score.$error,
                          disable: _vm.hasResults
                        },
                        on: { input: _vm.$v.minimum_score.$touch },
                        model: {
                          value: _vm.minimum_score,
                          callback: function($$v) {
                            _vm.minimum_score = $$v
                          },
                          expression: "minimum_score"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-4" },
                [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("status")))
                  ]),
                  _c("q-btn-toggle", {
                    attrs: {
                      "toggle-color": _vm.getColorStatusButton,
                      options: _vm.statuses
                    },
                    model: {
                      value: _vm.status,
                      callback: function($$v) {
                        _vm.status = $$v
                      },
                      expression: "status"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
              _c(
                "div",
                {
                  staticClass: "col-xs-12 col-sm-3",
                  class: _vm.getOrder("cancel")
                },
                [
                  _c("q-btn", {
                    staticClass: "full-width",
                    attrs: {
                      color: "tertiary",
                      label: _vm.$t("back"),
                      icon: "fas fa-chevron-left"
                    },
                    on: {
                      click: function($event) {
                        return _vm.returnToTests()
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "col-xs-12 col-sm-3",
                  class: _vm.getOrder("save")
                },
                [
                  _c("q-btn", {
                    staticClass: "full-width",
                    attrs: {
                      color: "secondary",
                      label: _vm.$t("save"),
                      icon: "far fa-save"
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveTest("save_test")
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]
        : _vm._e(),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeItem },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeItem()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      ),
      _c("new-question", {
        attrs: {
          id_live_class: _vm.id_live_class,
          id_test: _vm.id_test,
          id_question: _vm.id_question,
          add_question: _vm.add_question,
          has_results: _vm.hasResults
        },
        on: {
          returnToQuestions: function($event) {
            return _vm.returnToQuestions()
          }
        }
      }),
      _c("import-test", {
        attrs: { id_test: _vm.id_test, import_test: _vm.import_test },
        on: {
          returnToQuestions: function($event) {
            return _vm.returnToQuestions()
          }
        }
      }),
      _vm.show_test_preview
        ? _c("test-preview", {
            attrs: {
              show_test_preview: _vm.show_test_preview,
              title: _vm.title,
              questions: _vm.questions,
              randomize_questions: _vm.randomize_questions,
              randomize_answers: _vm.randomize_answers
            },
            on: {
              returnToQuestions: function($event) {
                return _vm.returnToQuestions()
              }
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }